import {createTheme,ThemeProvider} from '@mui/material/styles'

const CustomTheme = createTheme({
    direction: 'rtl',
    typography:{
        fontFamily:'iranYekanRegular',
    },
});

export default CustomTheme;